import * as _ from "lodash"
import {ErrorMessage_restate} from "../PA.Core/Basic/MessageUtils";
import {ActSpendBO} from "./ActSpendBO";

export class ActSpendBOValidations {

    static async ValidateFields(aBO: ActSpendBO): Promise<void> {

        ErrorMessage_restate(aBO.ValidateMessageProvider,
            _.isEmpty(aBO.WB_ActSpend.cif.CONTROL_POINT_ID),
            "emptyID", "Control Point Id cannot be empty")

        ErrorMessage_restate(aBO.ValidateMessageProvider,
            _.isEmpty(aBO.WB_ActSpend.cif.CONTROL_POINT_NAME),
            "emptyName", "Control Point Name cannot be empty")

    }
}